import { Iblog } from '@/interfaces/entities/blog';
import { ApiRequestConfig, apiService } from './api.service';

import { IApiService } from '@/interfaces/services/IApiService';

class BlogService {
    api: IApiService<ApiRequestConfig>;

    constructor(api: IApiService<ApiRequestConfig>) {
        this.api = api;
    }

    async getAllBlogs(pageNumber: number, config?: ApiRequestConfig) {
        return await this.api.get<{ data: Iblog[]; pageCount: number }>(
            `/blog?page[number]=${pageNumber}&sort[id]=DESC`,
            config,
        );
    }

    async deleteBlog(id: number) {
        return await this.api.delete(`/blog/${id}`);
    }

    async editBlog(id: number, blog: FormData) {
        return await this.api.patch(`/blog/edit/${id}`, blog, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }

    async newBlog(blog: FormData) {
        return await this.api.post(`/blog`, blog, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
    }
}

export const blogService = new BlogService(apiService);
